import { render, staticRenderFns } from "./AdminDeleteFormCard.vue?vue&type=template&id=12649818&scoped=true&"
import script from "./AdminDeleteFormCard.vue?vue&type=script&lang=js&"
export * from "./AdminDeleteFormCard.vue?vue&type=script&lang=js&"
import style0 from "./AdminDeleteFormCard.vue?vue&type=style&index=0&id=12649818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12649818",
  null
  
)

export default component.exports